export default [
  {
    path: '/icySysSetting/batchExportSizeImg',
    name: 'batchExportSizeImg',
    meta: {
      title: '批量生成尺码图',
    },
    component: function(resolve) {
      require(['COMPONENTS/icySysSetting/batchExportSizeImg/main.vue'], resolve)
    }
  },
  {
    path:'/icySysSetting',
    name: 'icySysSetting',
    meta: {
      title: 'ICY-系统设置',
    },
    component: function(resolve) {
      require(['COMPONENTS/icySysSetting/main.vue'], resolve)
    }
  },
  {
    path: '/icySysSetting/categoryManage',
    name: 'categoryManage',
    meta: {
      title: '分类管理'
    },
    component(resolve) {
      require(['COMPONENTS/icySysSetting/categoryManage/main.vue'], resolve)
    }
  },
  {
    path: '/icySysSetting/sizeImgList',
    name: 'sizeImgList',
    meta: {
      title: '尺码图模版管理',
    },
    component: function(resolve) {
      require(['COMPONENTS/icySysSetting/sizeImgList/main.vue'], resolve)
    }
  }
]